const d = [
  {
    text: '',
    links_to: 'news'
  },
  {
    text: 'Today’s news',
    links_to: 'news'
  },
  {
    text: 'Headlines',
    links_to: 'news'
  },
  {
    text: 'Buy anything',
    links_to: 'ecommerce'
  },
  {
    text: 'Low prices',
    links_to: 'ecommerce'
  },
  {
    text: 'Absolutely everything',
    links_to: 'ecommerce'
  },
  {
    text: 'What\'s happening today',
    links_to: 'social'
  },
  {
    text: 'Endless variety',
    links_to: 'ecommerce'
  },
  {
    text: 'Chirpr',
    links_to: 'social'
  },
  {
    text: 'You need this',
    links_to: 'ecommerce'
  },
  {
    text: 'See where my friends are',
    links_to: 'social'
  },
  {
    text: 'Location history',
    links_to: 'social'
  },
  {
    text: 'What we shared for you',
    links_to: 'social'
  },
  {
    text: 'We need you to know',
    links_to: 'news'
  },
  {
    text: 'XYZ News',
    links_to: 'news'
  },
  {
    text: 'Sahara',
    links_to: 'ecommerce'
  },
  {
    text: 'The end of the world is nigh',
    links_to: 'news'
  },
  {
    text: 'Join the conversation',
    links_to: 'social'
  },
  {
    text: 'Judge your friends',
    links_to: 'social'
  },
  {
    text: 'Apocalypse now?',
    links_to: 'news'
  },
  {
    text: 'Invade their privacy',
    links_to: 'social'
  },
  {
    text: 'Enjoy retail therapy',
    links_to: 'ecommerce'
  },
  {
    text: 'Juicy gossip',
    links_to: 'social'
  },
  {
    text: 'Reinforce prejudices',
    links_to: 'news'
  },
  {
    text: 'Quality journalism',
    links_to: 'news'
  },
  {
    text: 'Quick deals for you',
    links_to: 'ecommerce'
  },
  {
    text: 'Quietly stalk',
    links_to: 'social'
  },
  {
    text: 'Amazing special offers',
    links_to: 'ecommerce'
  },
  {
    text: 'Quash those rumours',
    links_to: 'social'
  },
  {
    text: 'Meaningless quotes',
    links_to: 'news'
  },
  {
    text: 'Equip my life',
    links_to: 'ecommerce'
  },
  {
    text: 'Maximum profit',
    links_to: 'ecommerce'
  },
  {
    text: 'Expose yourself',
    links_to: 'social'
  },
  {
    text: 'Existential crisis',
    links_to: 'social'
  },
  {
    text: 'Explore the news',
    links_to: 'news'
  },
  {
    text: 'Glitz and glamour',
    links_to: 'social'
  },
  {
    text: 'The world is crazy',
    links_to: 'news'
  },
  {
    text: 'Every size, everything',
    links_to: 'ecommerce'
  },
  {
    text: 'Where have you been?',
    links_to: 'social'
  },
  {
    text: 'Submit an update',
    links_to: 'social'
  },
  {
    text: 'Believe everything you read',
    links_to: 'news'
  }
];


const status_data = [
  {
    text: 'RoboGirl saves you the hassle of thinking of a present, they always like whatever you give them!',
    links_to: 'ecommerce'
  },
  {
    text: 'I’ve saved so much money by investing in Robogirl because I never have to spend money on good clothes. She likes whatever I wear!',
    links_to: 'ecommerce'
  },
  {
    text: '#robogirl always agrees with my restaurant choices, result!',
    links_to: 'ecommerce'
  },
  {
    text: 'NanoDoc is good and bad. Good because I never get ill again. Bad that can’t use being ill as an excuse to not go somewhere',
    links_to: 'ecommerce'
  },
  {
    text: 'I never leave my house without my wallet ever again. Thanks MemoryBoost',
    links_to: 'ecommerce'
  },
  {
    text: 'What’s the point in going outside ever again when you can put on the Optic Breach VR Suit?',
    links_to: 'ecommerce'
  },
  {
    text: 'raining outside again? no worries, I just live my life through vr',
    links_to: 'ecommerce'
  },
  {
    text: `I can eat meat and not feel guilty cos clean meat co doesn’t harm any animals, amazing!`,
    links_to: 'ecommerce'
  },
  {
    text: 'using filtr8 means I don’t contribute to climate change – now I feel much better about travelling to mars.',
    links_to: 'ecommerce'
  },
  {
    text: 'Remember to not use Filtr8 when you do exercise, used it all up on a few runs!',
    links_to: 'ecommerce'
  },
  {
    text: 'I’m so glad I can stop being vegetarian now, with clean meat co I don’t have to eat mushroom burgers ever again!',
    links_to: 'ecommerce'
  },
  {
    text: 'before I had the ampere model 7, I was constantly swerving potholes. now I can drive without thinking about them ever again.',
    links_to: 'ecommerce'
  },
  {
    text: 'Overtaking has never been easier than in the Ampere Model 7. I can just fly over everybody.',
    links_to: 'ecommerce'
  },
  {
    text: 'I’m so glad that they’ve upgraded space travel. Was getting bored of going to the moon. Thanks Infinity Z',
    links_to: 'ecommerce'
  },
  {
    text: 'does anyone understand clean meat co? their burgers taste exactly the same as real beef??',
    links_to: 'ecommerce'
  },
  {
    text: 'Netflix and Chills  #loveRoboGirl',
    links_to: 'ecommerce'
  },
  {
    text: 'Eat Clean #CleanMeatco',
    links_to: 'ecommerce'
  },
  {
    text: 'Live. Laugh. Love #RoboGirl',
    links_to: 'ecommerce'
  },
  {
    text: 'Feel the difference #vrSuit',
    links_to: 'ecommerce'
  },
  {
    text: 'To #InfinityZ and beyond!',
    links_to: 'ecommerce'
  },
  {
    text: 'No appointment, no worry #NanoDoc',
    links_to: 'ecommerce'
  },
  {
    text: 'Saving the planet, one breath at a time #Filtr8',
    links_to: 'ecommerce'
  },
  {
    text: 'No animals were harmed in the making of this hashtag #CleanMeatCo',
    links_to: 'ecommerce'
  }
];